import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { Trans } from 'react-i18next';

import { PAYMENT_METHOD_ICON_COMPONENT_MAPPING } from './PaymentMethodIcon.js';
import './ExpandButton.css';

const ExpandButton = ({
    onClick,
    paymentMethods = [],
    isDisabled = false,
    isRefundContext = false,
    refundFee,
    minAmountForCreditRequired
}) => {
    return (
        <div className="wz-lyriapay-expandbutton" onClick={onClick} disabled={isDisabled}>
            <div className="wz-lyriapay-expandbutton-labels">
                <div className="wz-lyriapay-expandbutton-labels-pm">
                    {paymentMethods.map(p => p.label).join(' / ')}
                </div>
                {isRefundContext && minAmountForCreditRequired && isDisabled && (
                    <div className="wz-lyriapay-expandbutton-labels-mincredit">
                        <Trans i18nKey="minAmountForCredit" />{minAmountForCreditRequired}
                    </div>
                )}
                {isRefundContext && refundFee && !isDisabled && (
                    <div className="wz-lyriapay-expandbutton-labels-refundfee">
                        <Trans i18nKey="refundFee" />{refundFee}
                    </div>
                )}
            </div>
            <div
                className={
                    cn(
                        'wz-lyriapay-expandbutton-icons',
                        {'wz-lyriapay-expandbutton-icons-single': paymentMethods.length === 1}
                    )
                }
            >
                {paymentMethods
                    .filter(p => p.payment_method in PAYMENT_METHOD_ICON_COMPONENT_MAPPING)
                    .map(p => {
                        const Component = PAYMENT_METHOD_ICON_COMPONENT_MAPPING[p.payment_method];
                        return <Component key={p.payment_method} className="wz-lyriapay-expandbutton-icon" />;
                    })
                }
            </div>
        </div>
    );
};

ExpandButton.propTypes = {
    onClick: PropTypes.func.isRequired,
    paymentMethods: PropTypes.arrayOf(PropTypes.shape({
        label: PropTypes.string.isRequired,
        payment_method: PropTypes.string.isRequired,
    })).isRequired,
    isDisabled: PropTypes.bool.isRequired,
    isRefundContext: PropTypes.bool,
    refundFee: PropTypes.string,
    minAmountForCreditRequired: PropTypes.string
};

export default ExpandButton;
